
function Footer() {

    return (
      <div>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
          <path
            fill="#f7ce68"
            fillOpacity="1"
            d="M0,32L20,48C40,64,80,96,120,122.7C160,149,200,171,240,165.3C280,160,320,128,360,112C400,96,440,96,480,122.7C520,149,560,203,600,186.7C640,171,680,85,720,85.3C760,85,800,171,840,192C880,213,920,171,960,128C1000,85,1040,43,1080,69.3C1120,96,1160,192,1200,213.3C1240,235,1280,181,1320,170.7C1360,160,1400,192,1420,208L1440,224L1440,320L1420,320C1400,320,1360,320,1320,320C1280,320,1240,320,1200,320C1160,320,1120,320,1080,320C1040,320,1000,320,960,320C920,320,880,320,840,320C800,320,760,320,720,320C680,320,640,320,600,320C560,320,520,320,480,320C440,320,400,320,360,320C320,320,280,320,240,320C200,320,160,320,120,320C80,320,40,320,20,320L0,320Z"
          ></path>
        </svg>
      </div>
    );
}

export default Footer;
